import { createApp } from 'vue'
import { VuelidatePlugin } from '@vuelidate/core';
import Toast, { POSITION, PluginOptions } from "vue-toastification";
import { createI18n } from 'vue-i18n';

import App from './App.vue'
import router from './router'
import { store } from './store'
import layout from './layout';
import { messages, defaultLocale } from "i18n";
// Tailwind Config
import './assets/css/styles.css'
// vue-toastification
import "vue-toastification/dist/index.css";
import { Locales } from 'i18n/locales';

// Setup our toast configuations
const toastOptions: PluginOptions = {
    // Setting the global default position
    position: POSITION.TOP_RIGHT,
    transition: "Vue-Toastification__bounce",
    maxToasts: 3,
    newestOnTop: true,
    timeout: 3000
}

const i18n = createI18n({
    locale: Locales.EN, // Set default Lang
    fallbackLocale: defaultLocale, // set fallback locale
    messages
})


const app = createApp(App);

app.use(store);
app.use(i18n);
app.use(router);
app.use(VuelidatePlugin);
app.use(Toast, toastOptions);

// Add the Layouts as global components
layout.bind(app);


app.mount('#app')
